// Shared module
// Use this module to export components, directives, and pipes.
// Do not provide services here

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from './header/header.component';
import { StageNavComponent } from './stage-nav/stage-nav.component';
import { GaugeChartComponent } from './gauge-chart/gauge-chart.component';
import { AidCostIllustrationComponent } from './aid-cost-illustration/aid-cost-illustration.component';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';

const materialModules = [
  MatCardModule, MatButtonModule, MatDialogModule,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    materialModules,
    GaugeChartComponent,
    AidCostIllustrationComponent,
  ],
  declarations: [
    HeaderComponent,
    StageNavComponent,
  ],
  exports: [
    HeaderComponent,
    StageNavComponent,
    materialModules,
    GaugeChartComponent,
    AidCostIllustrationComponent,
  ]
})
export class SharedModule { }
